import { render, staticRenderFns } from "./StatsRevenueArticleCategory.vue?vue&type=template&id=5ae15dba&scoped=true&"
import script from "./StatsRevenueArticleCategory.vue?vue&type=script&lang=js&"
export * from "./StatsRevenueArticleCategory.vue?vue&type=script&lang=js&"
import style0 from "./StatsRevenueArticleCategory.vue?vue&type=style&index=0&id=5ae15dba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae15dba",
  null
  
)

export default component.exports